import { render, staticRenderFns } from "./AdToStoreMenu.vue?vue&type=template&id=c64901fc&"
import script from "./AdToStoreMenu.vue?vue&type=script&lang=js&"
export * from "./AdToStoreMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports